// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Login_background__U5\\+jp {
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-top-right-radius: 50px;
  border-bottom-right-radius: 50px;
}

.Login_loginContainer__kub2- {
  display: flex;
  height: 100vh;
  width: 100%;
}

.Login_loginContainer__kub2- .Login_logo__j1HlC {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0px 30px;
}

.Login_formBg__kqiay {
  flex-grow: 1;
  position: relative;
}

.Login_loginForm__QiL9D {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.Login_inputs__PlIQy {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 400px;
}

.Login_loginContainer__kub2- h2 {
  font-size: 55px;
  font-weight: 600;
  line-height: 71.5px;
  color: white;
}

.Login_input__\\+gaU2 {
  padding: 8px 16px;
  display: flex;
  flex-direction: column;
  border-radius: 12px;
  gap: 8px;
  border: 1px solid #ededed;
  color: #ededed;
  background-color: transparent;
  align-items: start;
}

.Login_input__\\+gaU2 input {
  color: #ededed;
  background-color: transparent;
  border: none;
}

.Login_loginBtn__n0So3 {
  width: 400px;
  height: 60px;
  border-radius: 8px;
  padding: 0px 16px;
  margin-top: 40px;
  line-height: 24px;
  color: #676c7e;
  border: none;
  cursor: pointer;
  background-color: white;
}

.Login_loginBtn__n0So3:disabled {
  background-color: rgb(219, 218, 218);
}

.Login_notifications__j3cIq {
  margin-top: 2rem;
}

.Login_loginForm__QiL9D input,
.Login_loginForm__QiL9D label {
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/pages/login/Login.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,cAAc;EACd,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,YAAY;EACZ,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;AACb","sourcesContent":[".background {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  z-index: -1;\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: cover;\r\n  border-top-right-radius: 50px;\r\n  border-bottom-right-radius: 50px;\r\n}\r\n\r\n.loginContainer {\r\n  display: flex;\r\n  height: 100vh;\r\n  width: 100%;\r\n}\r\n\r\n.loginContainer .logo {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  padding: 0px 30px;\r\n}\r\n\r\n.formBg {\r\n  flex-grow: 1;\r\n  position: relative;\r\n}\r\n\r\n.loginForm {\r\n  position: relative;\r\n  z-index: 1;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  height: 100%;\r\n}\r\n\r\n.inputs {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 16px;\r\n  width: 400px;\r\n}\r\n\r\n.loginContainer h2 {\r\n  font-size: 55px;\r\n  font-weight: 600;\r\n  line-height: 71.5px;\r\n  color: white;\r\n}\r\n\r\n.input {\r\n  padding: 8px 16px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  border-radius: 12px;\r\n  gap: 8px;\r\n  border: 1px solid #ededed;\r\n  color: #ededed;\r\n  background-color: transparent;\r\n  align-items: start;\r\n}\r\n\r\n.input input {\r\n  color: #ededed;\r\n  background-color: transparent;\r\n  border: none;\r\n}\r\n\r\n.loginBtn {\r\n  width: 400px;\r\n  height: 60px;\r\n  border-radius: 8px;\r\n  padding: 0px 16px;\r\n  margin-top: 40px;\r\n  line-height: 24px;\r\n  color: #676c7e;\r\n  border: none;\r\n  cursor: pointer;\r\n  background-color: white;\r\n}\r\n\r\n.loginBtn:disabled {\r\n  background-color: rgb(219, 218, 218);\r\n}\r\n\r\n.notifications {\r\n  margin-top: 2rem;\r\n}\r\n\r\n.loginForm input,\r\n.loginForm label {\r\n  width: 100%;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"background": `Login_background__U5+jp`,
	"loginContainer": `Login_loginContainer__kub2-`,
	"logo": `Login_logo__j1HlC`,
	"formBg": `Login_formBg__kqiay`,
	"loginForm": `Login_loginForm__QiL9D`,
	"inputs": `Login_inputs__PlIQy`,
	"input": `Login_input__+gaU2`,
	"loginBtn": `Login_loginBtn__n0So3`,
	"notifications": `Login_notifications__j3cIq`
};
export default ___CSS_LOADER_EXPORT___;
